import { LoadingOutlined } from "@ant-design/icons";
import { QrPlatform } from "src/common/client-platform";
import styles from "./index.module.scss";

interface ClientAutoLoginLoadingProps {
  platform: QrPlatform;
}

const PLATFORM_COPY = {
  feishu: {
    ariaLabel: "飞书登录加载中",
  },
  wework: {
    ariaLabel: "企业微信登录加载中",
  },
} satisfies Record<QrPlatform, { ariaLabel: string }>;

export default function ClientAutoLoginLoading({
  platform,
}: ClientAutoLoginLoadingProps) {
  const copy = PLATFORM_COPY[platform];

  return (
    <div
      className={styles.wrapper}
      role="status"
      aria-live="polite"
      aria-label={copy.ariaLabel}
    >
      <LoadingOutlined className={styles.icon} />
    </div>
  );
}
